import React from 'react';
import { ElementLoader, Paper } from 'ui';
import { CodeMappingsHeader } from '../common/code-mappings-header';
import { CodeMappingResults } from './code-mapping-results';
import { HeaderSecondary } from 'app/area/code-mappings/components/header-secondary';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';
import { CodeMappingsRendererProps } from 'app/area/code-mappings/components/types';
import styles from './code-mapping-renderer.scss';

export class CodeMappingsRenderer extends React.PureComponent<CodeMappingsRendererProps> {

  public componentDidMount() {
    this.props.loadList(this.props.id, { codetablesOnly: true });
  }

  public render() {
    const { id, fileName, importSet, missingMappingsExists, listItems, modifiedItems, updatingExternalValue,
      fetchingList, fetchingItemId, validation, metadata, translation, codetableOptions, codetableIds, codetableAccess,
      loadItem, modifyItem, copyToAll, loadCodetableOptions, loadMetadata, loadCodetablesAccess, loadCategoryOptions
    } = this.props;

    return <div className="entity-view">
      <Paper componentId="code-mappings-paper" className={undefined}>
        <div className="container main-grid">
          {!!listItems
            ? <CodeMappingsHeader translation={translation} />
            : null}

          {!fetchingList && listItems?.length > 0
            && <div className={`${styles.alertInfo} mb-4`}>
              <p>{translation.changes_saved}</p>
            </div>}

          {!fetchingList
            ? <HeaderSecondary
              fileName={fileName?.description}
              importSet={importSet?.description}
              translation={translation} />
            : <ElementLoader />}

          {listItems?.length > 0
            ? <CodeMappingResults
              id={id}
              importSetId={importSet?.value}
              codetableOptions={codetableOptions}
              loadItem={loadItem}
              fetchingItemId={fetchingItemId}
              updatingExternalValue={updatingExternalValue}
              loadCodetableOptions={loadCodetableOptions}
              loadCategoryOptions={loadCategoryOptions}
              codetableAccess={codetableAccess}
              loadCodetablesAccess={loadCodetablesAccess}
              metadata={metadata}
              loadMetadata={loadMetadata}
              mappingsList={listItems}
              modifiedMappings={modifiedItems}
              codetableIds={codetableIds}
              modifyItem={modifyItem}
              copyToAll={copyToAll}
              missingMappingsExists={missingMappingsExists}
              validation={validation}
              translation={translation} />
            : (
              listItems?.length === 0 && (
                missingMappingsExists
                  ?
                  <div className={styles.alertInfo}>
                    <p>{translation.missing_codes_info}</p>
                  </div>
                  : <div className={styles.alertInfo}>
                    <p>{translation.no_missing_mappings}</p>
                  </div>
              )
            )
          }
        </div>
        <ScrollToTop />
      </Paper>
    </div>;
  }
}
